import { render, staticRenderFns } from "./ConcurrentCustomer.vue?vue&type=template&id=0913db48&scoped=true"
import script from "./ConcurrentCustomer.vue?vue&type=script&lang=js"
export * from "./ConcurrentCustomer.vue?vue&type=script&lang=js"
import style0 from "./ConcurrentCustomer.vue?vue&type=style&index=0&id=0913db48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0913db48",
  null
  
)

export default component.exports